export enum CheckpointType {
	All = 'clear',
	TSAPRE = 'tsa-pre',
	FIS = 'fis',
}
